<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BRklN4/tc-custom/9781939038722.jpg?1737679392664" alt="This image is the cover for the book Trip Wire, Renegade Justice Thrillers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Trip Wire, Renegade Justice Thrillers
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A serial killer’s daughter fights to escape her past in this explosive thriller from the <i>New York Times</i>–bestselling author of <i>Look Away</i>.</b><br/><br/><i>Heartless killer—or helpless victim?</i><br/><br/> It’s perfectly normal to be a little shaky on your first day back to work. Especially if you’re Morgan Ames, returning to work after killing her serial killer father, waking up from a coma, fighting back through rehab . . . and, with the help of her boyfriend, keeping her vow never to kill again.<br/><br/> Except when Morgan walks into the Galloway and Stone offices, she finds her boss holding a bomb.<br/><br/> Definitely no time for the shakes as Morgan jumps right back into her old life and saves the day. But the bomber has other ideas, igniting a killing spree targeting those Morgan holds most dear. <br/><br/> Morgan must decide what to sacrifice: her promise to never kill again or the lives of everyone she loves.<br/><br/><b>Praise for CJ Lyons’ thrillers</b><br/><br/> “Everything a great thriller should be—action packed, authentic, and intense.” —Lee Child, #1 <i>New York Times</i>–bestselling author<br/><br/> “A pulse-pounding adrenalin rush!” —Lisa Gardner, #1 <i>New York Times</i>–bestselling author<br/><br/> “A high stakes adventure with dire consequences.” —Steve Berry, <i>New York Times</i>–bestselling author<br/><br/> “A compelling new voice in thriller writing . . . I love how the characters come alive on every page.” —Jeffery Deaver, <i>New York Times</i>–bestselling author</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        CJ Lyons
      </h2>
      
      <p class="authorDescription body article">New York Times and USA Today bestselling author of over forty novels, former pediatric ER doctor CJ Lyons has lived the life she writes about in her cutting-edge Thrillers with Heart.    CJ has been called a “master within the genre" (Pittsburgh Magazine) and her work has been praised as “breathtakingly fast-paced” and “riveting” (Publishers Weekly) with “characters with beating hearts and three dimensions” (Newsday).   Her novels have twice won the International Thriller Writers’ prestigious Thriller Award, the RT Reviewers’ Choice Award, the Readers’ Choice Award, the RT Seal of Excellence, and the Daphne du Maurier Award for Excellence in Mystery and Suspense.   Learn more about CJ’s Thrillers with Heart at www.CJLyons.net</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Edgy Reads
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?247aa966